import { ActionContext } from 'vuex'
import { IRootState } from '@/store'

export enum HelpPagesMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_ALL_HELP_PAGES = 'SET_ALL_HELP_PAGES',
  SET_ALERTS = 'SET_ALERTS'
}

export enum HelpPagesActionType {
  FETCH_ALL_HELP_PAGES = 'FETCH_ALL_HELP_PAGES',
  FETCH_ALERTS='FETCH_ALERTS'
}

export interface IHelpPages {
  id: string
  section: string
  title: string
  body: string
  mandatory?: string
  file: {
    link: string
  }
  page: number,
  mgnllastModified: string
  newCapability: boolean
}

export interface IFetchHelpPagesRequest {
  limit?: number
  offset?: number
  market?: string
  userType?: string
  language?: string
  sortType?: string
  CustomerType? : string | null
}

export interface IFetchHelpPagesResponse {
  total: number
  offset: number
  limit: number
  results: Array<IHelpPages>
}

export interface IHelpPagesState {
  helpPages: Array<IHelpPages>
  loading: boolean
  alerts: Array<IHelpPages>
}

export interface IHelpPagesMutations<S = IHelpPagesState> {
  [HelpPagesMutationType.SET_LOADING](state: S, payload: boolean): void
  [HelpPagesMutationType.SET_ALL_HELP_PAGES](state: S, payload: Array<IHelpPages>): void
}

export type AugmentedHelpPagesActionsType = {
  commit<K extends keyof IHelpPagesMutations>(
    key: K,
    payload: Parameters<IHelpPagesMutations[K]>[1]
  ): ReturnType<IHelpPagesMutations[K]>
} & Omit<ActionContext<IHelpPagesState, IRootState>, 'commit'>

export interface IHelpPagesActions {
  [HelpPagesActionType.FETCH_ALL_HELP_PAGES](
    { commit }: AugmentedHelpPagesActionsType,
    payload: IFetchHelpPagesRequest
  ): void
}
